<!--
  - Copyright (c) 2022.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div>
        <van-nav-bar
            :title="info.title"
            :left-text="infoColumn.title"
            left-arrow
            fixed
            @click-left="backClicked"
        />

        <div style="margin-top: 46px;">
            <h2 style="text-align: center;" v-if="rc">{{ info.title }}</h2>
            <div style="text-align: center;color:#999999;" v-if="rc">阅读次数：{{ info.viewCount }}</div>
            <div class="info-content">
                <div style="text-align: center;">
                    <img :src="baseUrl+info.coverUrl"
                         style="max-width: 50%; width: 100%;height: auto;margin-bottom: 20px;" v-if="info.coverUrl"/>
                </div>
                <div v-html="info.content"></div>
            </div>
        </div>
    </div>
</template>

<script>

import qs from "qs";
import http, {BASE_CDN_URL, BASE_URL} from "@/utils/http";

export default {
    name: "Info",
    data() {
        return {
            baseUrl: BASE_URL,
            baseCdnUrl: BASE_CDN_URL,
            info: {title: ''},
            infoColumn: {id: 0, title: ''},
            spinShow: false,
            id: '',
            rc: true,
            levels: [],
            attaches: [],

            lastId: '',
        };
    },
    components: {},
    watch: {
        '$route.query.id'() {
            var id = this.$route.query.id ? this.$route.query.id : '';
            var infoColumnId = this.$route.query.icid ? this.$route.query.icid : '';

            var lastId = id + '-' + infoColumnId;
            if (lastId === this.lastId) {
                return;
            }
            this.lastId = lastId;

            this.loadInfoDetail(infoColumnId, id, (info, levels, attaches) => {
                this.processInfoDetail(info, levels, attaches);
                // console.log(this.info)
            });

        },
        '$route.query.icid'() {
            var id = this.$route.query.id ? this.$route.query.id : '';
            var infoColumnId = this.$route.query.icid ? this.$route.query.icid : '';

            var lastId = id + '-' + infoColumnId;
            if (lastId === this.lastId) {
                return;
            }
            this.lastId = lastId;

            this.loadInfoDetail(infoColumnId, id, (info, levels, attaches) => {
                this.processInfoDetail(info, levels, attaches);
                // console.log(this.info)
            });
        }
    },
    created() {
        var id = this.$route.query.id ? this.$route.query.id : '';
        var infoColumnId = this.$route.query.icid ? this.$route.query.icid : '';
        if (!id || !infoColumnId) {
            this.$router.replace('/');
            return;
        }

        var lastId = id + '-' + infoColumnId;
        if (lastId === this.lastId) {
            return;
        }
        this.lastId = lastId;

        this.rc = this.$route.query.rc !== '0'

        this.loadInfoDetail(infoColumnId, id, (info, levels, attaches) => {
            this.processInfoDetail(info, levels, attaches);
            // console.log(this.info)
        });
    },
    methods: {
        backClicked: function () {
            console.log(this.rc)
            if (this.rc) {
                this.$router.replace('/info_column?id=' + this.infoColumn.id);
            } else {
                console.log('go -1 called')
                this.$router.go(-1);
            }
        },
        processInfoDetail(info, levels, attaches) {
            if(info.content) {
                info.content = info.content.replace(/\/api\/ue\/ue\/image\//g, this.baseCdnUrl + '/api/ue/ue/image/');
            }
            this.info = info;
            this.levels = levels;
            this.attaches = attaches.filter(attach => attach.type === 0);
            if (levels.length > 0) {
                this.infoColumn = levels[levels.length - 1];
            }
            if (this.info.sourceLink) {
                // window.location.replace(this.info.sourceLink);
                this.$router.go(-1);
                window.location.href = this.info.sourceLink;
            }
        },
        loadInfoDetail(infoColumnId, infoId, callback) {
            this.spinShow = true;
            let payload = qs.stringify({infoColumnId: infoColumnId, infoId: infoId});
            http.post('/api/info/detail_info', payload).then(res => {
                this.spinShow = false;
                if (callback) {
                    callback(res.data.extra.info, res.data.extra.levels, res.data.extra.attaches);
                }
                // console.log(res.data)
            }).catch(() => this.spinShow = false);
        },
    },
}
</script>

<style scoped>
.info-content {
    margin-top: 10px;
    padding: 10px;
}

/deep/ .info-content img:not([width]) {
    width: 100%;
}
</style>